import { Link } from "react-router-dom";
import museum1 from "../../images/Ascoli P. Cart. Palale 18.jpg";
import museum2 from "../../images/Ascoli P. Cart. Palale 17.jpg";
import museum3 from "../../images/Immagine 043.jpg";
import digitalLibraryScreen from "../../images/digital-library-screen.png";
import SimpleLink from "../../utils/SimpleLink/SimpleLink";
import css from "./Museum.module.css";

export default function Museum() {
  return (
    <>
      <section style={{ backgroundColor: "#d0b8a5" }}>
        <div className="container col-xxl-8 px-4 py-5">
          <div className="row">
            <h1 className="text-center display-5 fw-semibold lh-1 mb-3">
              Museo fisico
            </h1>
          </div>
          <div className="row flex-lg-row-reverse align-items-center g-5 py-5">
            <div className="col-10 col-sm-8 col-lg-6">
              <div
                id="carouselMuseumControls"
                className="carousel slide carousel-fade"
                data-bs-ride="carousel"
              >
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <img
                      src={museum1}
                      className={`d-block w-100 mx-lg-auto img-fluid rounded-3 shadow-lg ${css["museum-carousel-img"]}`}
                      alt="Museo"
                      loading="lazy"
                    />{" "}
                  </div>
                  <div className="carousel-item">
                    <img
                      src={museum2}
                      className={`d-block w-100 mx-lg-auto img-fluid rounded-3 shadow-lg ${css["museum-carousel-img"]}`}
                      alt="Museo"
                      loading="lazy"
                    />{" "}
                  </div>
                  <div className="carousel-item">
                    <img
                      src={museum3}
                      className={`d-block w-100 mx-lg-auto img-fluid rounded-3 shadow-lg ${css["museum-carousel-img"]}`}
                      alt="Museo"
                      loading="lazy"
                    />{" "}
                  </div>
                </div>
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#carouselMuseumControls"
                  data-bs-slide="prev"
                >
                  <span
                    className="carousel-control-prev-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#carouselMuseumControls"
                  data-bs-slide="next"
                >
                  <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </div>
            <div className="col-lg-6">
              <p className="lead">
                Il Museo di Storia Naturale "Antonio Orsini", situato
                all'interno dei{" "}
                <SimpleLink
                  isDark={true}
                  href={"https://www.museicartierapapale.it/"}
                  target={"_blank"}
                >
                  Musei della Cartiera Papale
                </SimpleLink>{" "}
                di Ascoli Piceno, accoglie la vastissima collezione
                naturalistica dello scienziato ascolano Antonio Orsini negli
                arredi originali ottocenteschi. Il museo è suddiviso in diverse
                sezioni: Geognostica, dedicata alle rocce; Orittognostica,
                dedicata a minerali e fossili, Paleontologica, dedicata a
                fossili del paleolitico e mesozoico. Degni di nota sono un
                erbario con più di 11500 piante essiccate e catalogate, un
                epistolario composta da più di 4000 lettere, e diversi strumenti
                scientifici di ricerca.
              </p>
              <div className="d-grid gap-2 d-md-flex justify-content-md-start mt-4">
                <Link
                  to={"/antonio-orsini"}
                  className="btn btn-light btn-lg px-4"
                >
                  Antonio Orsini
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-light">
        <div className="container col-xxl-8 px-4 py-5">
          <div className="row">
            <h1 className="text-center display-5 fw-semibold lh-1 mb-3">
              Museo digitale
            </h1>
          </div>
          <div className="row flex-lg-row-reverse align-items-center g-5 py-5">
            <div className="col-10 col-sm-8 col-lg-6">
              <img
                src={digitalLibraryScreen}
                className="img-fluid border rounded-3 shadow-lg mb-4"
                alt="Screenshot"
                width="700"
                height="500"
                loading="lazy"
              />
            </div>
            <div className="col-lg-6">
              <p className="lead">
                L'epistolario presente nel museo è consultabile in formato
                digitale sulla piattaforma{" "}
                <SimpleLink
                  target={"_blank"}
                  href={"https://www.knowaysystems.it/"}
                >
                  Knoway Systems
                </SimpleLink>
                .
                <br />
                Grazie all'innovativo sistema BooKeeper, i testi sono stati
                digitalizzati e messi a disposizione per una maggiore facilità
                di fruizione e condivsione.
              </p>
              <div className="d-grid gap-2 d-md-flex justify-content-md-start mt-4">
                <a
                  className="btn btn-dark btn-lg px-4 me-sm-3"
                  href={
                    "https://www.knowaysystems.it/DigLibrary/Museo-di-Storia-Naturale-A.-Orsini"
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  Consulta
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
